<template>
  <div class="minNav">
    <el-header style="height: 70px">
      <router-link to="/" name="home" class="logo_box">
        <img class="logo" src="../assets/logo_new.png" />
        <div class="site_name">{{ siteName }}</div>
      </router-link>
      <el-button @click="drawer = true" type="" class="minNavBtn">
        <i class="el-icon-s-fold" />
      </el-button>
    </el-header>
    <el-drawer
      title=""
      :visible.sync="drawer"
      :direction="direction"
      :before-close="handleClose"
      size="300px; max-width:95%;"
    >
      <el-menu
        class="el-menu-min"
        mode="horizontal"
        :default-active="activeIndex"
      >
        <el-menu-item index="1" name="home" class="topNavBtn">
          <el-tooltip
            class="item"
            effect="dark"
            placement="bottom"
          >
            <el-link :underline="false" @click="goHome">首页</el-link>
          </el-tooltip>
        </el-menu-item>
        <el-menu-item index="2" name="events" class="topNavBtn">
          <el-tooltip
            class="item"
            effect="dark"
            placement="bottom"
          >
            <el-link :underline="false" @click="goEvents">会议活动</el-link>
          </el-tooltip>
        </el-menu-item>
        <LoginInfoBox @minMenuDrawer="hideDrawer" />
      </el-menu>
    </el-drawer>
  </div>
</template>

<script>
import LoginInfoBox from '@/components/LoginInfoBox.vue';
export default {
  name: 'MinNav',
  components: {
    LoginInfoBox,
  },
  props: {
    activeIndex: String,
    siteName: String,
  },

  data() {
    return {
      drawer: false,
      direction: 'rtl',
    };
  },
  methods: {
    handleClose() {
      this.drawer = false;
    },
    goHome() {
      this.drawer = false;
      this.$router.push({ path: '/' });
    },
    goEvents() {
      this.drawer = false;
      this.$router.push({ path: '/events' });
    },
    hideDrawer(data) {
      this.drawer = data;
    },
  },
};
</script>

<style scoped></style>
